module.exports = __webpack_public_path__ + "static/img/banner-18-sept-perancis.a4bb673.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-18-sept-perancis.png
// module id = McJN
// module chunks = 1